import * as React from "react";
import * as header from "./style.module.scss";
export const Header = ({ noLink }) => {
  return (
    <header className={header.header}>
      <a href={ !noLink && "/" } style={{ pointerEvents: noLink && 'none' }}>
        <img src="https://fs.advance.ru/landing-pages/icons/advance-logo/logo_2021.svg" alt="Advance"/>
        <p>Центр образовательных технологий</p>
      </a>
    </header>
  );
};
